<template>
    <section
        class="organic-products relative overflow-hidden"
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-easing="ease-in-out"
        data-wow-duration="3100"
    >
        <div class="container-lg relative">
            <img
                src="/assets/custom/img/vector-left.png"
                data-src="/assets/custom/img/vector-left.png"
                width="461"
                height="829"
                alt="vector"
                class="vector-left"
            />
            <img
                src="/assets/custom/img/vector-right.png"
                data-src="/assets/custom/img/vector-left.png"
                width="461"
                height="829"
                alt="vector"
                class="vector-right"
            />
            <div class="box text-center">
                <div class="circle">
                    <img
                        src="/assets/custom/img/bottle.jpg"
                        data-src="/assets/custom/img/bottle.jpg"
                        width="221"
                        height="221"
                        alt="organic"
                        class="rounded-circle"
                    />
                </div>
                <h2 class="text-dark font-bold">What's Organic Products</h2>
                <div class="d-flex  justify-content-center">
                    <div class="col-12 col-md-8">
                        Organic Products are made from the Plants which is grown
                        without pesticides, fungisides,GMO free.
                    </div>
                </div>
                <div class="d-flex row justify-content-center">
                    <a href="#" class="d-block px-2 px-md-4 tex link font-bold">
                        <span class="d-block">01</span>
                        What's Organic Products
                    </a>
                    <a href="#" class="d-block px-2 px-md-4 tex link font-bold">
                        <span class="d-block">02</span>
                        MRT Organic Products
                    </a>
                    <a href="#" class="d-block px-2 px-md-4 tex link font-bold">
                        <span class="d-block">03</span>
                        Why MRT Organic?
                    </a>
                    <a href="#" class="d-block px-2 px-md-4 tex link font-bold">
                        <span class="d-block">04</span>
                        Featured product
                    </a>
                </div>
            </div>
        </div>
        <div class="wall"></div>
    </section>
</template>
<script>
export default {
    name: "OrganicExplenation"
};
</script>
